import React, { useState, useContext } from "react";
import { globalInfo } from "../../App";
import { useParams, useNavigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { submitFormData } from "../../Utils/adminFunctions";

const AdminAddParticipantQualification = () => {
  const { ip_address } = useContext(globalInfo);
  const navigate = useNavigate();
  const { surveyID } = useParams();
  const [inputList, setInputList] = useState([{ question: "", answer: "" }]);
  const [requiredError, setRequiredError] = useState("");
  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { question: "", answer: "" }]);
  };
  const submitParticipantQualification = async (e) => {
    e.preventDefault();
    let inValid = 0;
    inputList.forEach((x) => {
      if (x.question == "" || x.answer == "") {
        inValid = 1;
      }
    });
    if (inValid == 1) {
      setRequiredError("Please fill required field.");
      return false;
    } else {
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append(
        "participant_qualification_json",
        JSON.stringify(inputList)
      );
      bodyFormData.append("entered_by_ip", ip_address);
      const response = await submitFormData(
        "add_survey_participant_qualification",
        bodyFormData
      );
      if (response.status == "success") {
        navigate("/AdminCreateSurveyQuestion/" + surveyID);
        setRequiredError("");
      } else {
        toast.warning(response.message, { autoClose: 1500 });
      }
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-body">
                        {inputList.map((x, i) => {
                          return (
                            <div className="row" key={i}>
                              <div className="col-md-5">
                                <div className="form-group">
                                  <span className="custom-label-font-weight">
                                    Question<i className="text-danger">*</i>
                                  </span>
                                  <input
                                    type="text"
                                    name="question"
                                    className="form-control"
                                    placeholder="Question"
                                    value={x.question}
                                    onChange={(e) => handleInputChange(e, i)}
                                  />
                                </div>
                              </div>

                              <div className="col-md-5">
                                <div className="form-group">
                                  <span className="custom-label-font-weight">
                                    Answer<i className="text-danger">*</i>
                                  </span>
                                  <select
                                    name="answer"
                                    className="form-control"
                                    value={x.answer}
                                    onChange={(e) => handleInputChange(e, i)}
                                  >
                                    <option value="">Select</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-2">
                                <div className="form-group">
                                  {inputList.length !== 1 && (
                                    <button
                                      className="fa fa-trash-o btn btn-danger dynamic-button-margin"
                                      onClick={() => handleRemoveClick(i)}
                                    ></button>
                                  )}{" "}
                                  {inputList.length - 1 === i && (
                                    <button
                                      className="fa fa-plus btn btn-success dynamic-button-margin"
                                      onClick={handleAddClick}
                                    ></button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        {requiredError && (
                          <span className="text-left text-danger">
                            {requiredError}
                          </span>
                        )}

                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-sm custom-btn-primary pull-right"
                            onClick={submitParticipantQualification}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddParticipantQualification;
